import React, { Component } from 'react';
import { connect } from 'react-redux';
import PreviewEventModal from '../../../../views/event/common/modal/PreviewEventModal';
import withModal from '../../../../lib/hoc/withModal';
import { eventActions } from '../../../../store/modules/event';

class PreviewEventModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'previewEventModal', value: false });
  };

  render() {
    return <PreviewEventModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.event.previewEventModal.isOpen,
    data: state.event.previewEventModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: eventActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PreviewEventModalContainer));
